"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iframeCopy = exports.iframeCvv = exports.iframeCardNumber = exports.fullName = exports.expiryCvv = exports.expiry = exports.hide = exports.cvv = exports.greyedOutcopyIcon = exports.greyedOutcopyButton = exports.copyIcon = exports.copyButton = exports.cardNumber = exports.card = exports.vgsIframe = void 0;

var _react = require("@emotion/react");

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 7%;\n  left: 5%;\n  color: ", ";\n  opacity: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.37em;\n  text-transform: none;\n\n  @media screen and (max-width: 320px) {\n    font-size: ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  letter-spacing: 2.4px;\n  width: 50%;\n  height: 12%;\n  position: absolute;\n  left: 5%;\n  top: 73%;\n  transform: translateY(-50%);\n\n  @media screen and (max-width: 320px) {\n    font-size: ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: absolute;\n  height: 100%;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: 63%;\n  height: 100%;\n  iframe {\n    display: block;\n    position: relative;\n    height: 100%;\n    width: 100%;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.3;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  background-color: ", ";\n  opacity: 0.3;\n  :hover {\n    background-color: ", ";\n  }\n  iframe {\n    background-color: ", ";\n    opacity: 0.3;\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  z-index: 3;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  border-radius: 50%;\n  right: 4%;\n  width: 32px;\n  height: 32px;\n  min-width: unset;\n  transform: translateY(-50%);\n  pointer-events: none;\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: absolute;\n  top: 50%;\n  right: 4%;\n  height: 32px;\n  width: 32px;\n  min-width: unset;\n  transform: translateY(-50%);\n\n  iframe {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    transition: background-color 0.5s ease;\n    background-color: ", ";\n    :hover {\n      background-color: ", ";\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 9%;\n  position: absolute;\n  left: 5%;\n  right: 5%;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  letter-spacing: 3.5px;\n  word-spacing: 5px;\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  @media screen and (max-width: 360px) {\n    font-size: 0.875rem;\n  }\n\n  @media screen and (max-width: 320px) {\n    font-size: 0.75rem;\n  }\n\n  iframe {\n    display: block;\n    position: relative;\n    height: 100%;\n    width: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  display: block;\n  z-index: 0;\n  border-radius: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 330px;\n  width: 100%;\n  font-weight: ", ";\n  border-radius: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var vgsIframe = function vgsIframe(_ref) {
  var fontWeights = _ref.fontWeights;
  return (0, _react.css)(_templateObject(), fontWeights.medium);
};

exports.vgsIframe = vgsIframe;
var card = (0, _react.css)(_templateObject2());
exports.card = card;

var cardNumber = function cardNumber(_ref2) {
  var fonts = _ref2.fonts,
      fontSizes = _ref2.fontSizes,
      colors = _ref2.colors;
  return (0, _react.css)(_templateObject3(), fonts.heading3, fontSizes.heading3, colors.muted);
};

exports.cardNumber = cardNumber;

var copyButton = function copyButton(_ref3) {
  var _colors$primary, _colors$primary2;

  var colors = _ref3.colors;
  return (0, _react.css)(_templateObject4(), (_colors$primary = colors.primary) === null || _colors$primary === void 0 ? void 0 : _colors$primary.medium, (_colors$primary2 = colors.primary) === null || _colors$primary2 === void 0 ? void 0 : _colors$primary2.dark);
};

exports.copyButton = copyButton;
var copyIcon = (0, _react.css)(_templateObject5());
exports.copyIcon = copyIcon;

var greyedOutcopyButton = function greyedOutcopyButton(_ref4) {
  var _colors$primary3, _colors$primary4, _colors$primary5, _colors$primary6;

  var colors = _ref4.colors;
  return (0, _react.css)(_templateObject6(), (_colors$primary3 = colors.primary) === null || _colors$primary3 === void 0 ? void 0 : _colors$primary3.medium, (_colors$primary4 = colors.primary) === null || _colors$primary4 === void 0 ? void 0 : _colors$primary4.medium, (_colors$primary5 = colors.primary) === null || _colors$primary5 === void 0 ? void 0 : _colors$primary5.medium, (_colors$primary6 = colors.primary) === null || _colors$primary6 === void 0 ? void 0 : _colors$primary6.medium);
};

exports.greyedOutcopyButton = greyedOutcopyButton;
var greyedOutcopyIcon = (0, _react.css)(_templateObject7());
exports.greyedOutcopyIcon = greyedOutcopyIcon;
var cvv = (0, _react.css)(_templateObject8());
exports.cvv = cvv;
var hide = (0, _react.css)(_templateObject9());
exports.hide = hide;
var expiry = (0, _react.css)(_templateObject10());
exports.expiry = expiry;

var expiryCvv = function expiryCvv(_ref5) {
  var fonts = _ref5.fonts,
      fontSizes = _ref5.fontSizes,
      colors = _ref5.colors;
  return (0, _react.css)(_templateObject11(), fonts.body4, fontSizes.body4, colors.muted, fontSizes.caption2);
};

exports.expiryCvv = expiryCvv;

var fullName = function fullName(_ref6) {
  var colors = _ref6.colors,
      fonts = _ref6.fonts,
      fontSizes = _ref6.fontSizes,
      fontWeights = _ref6.fontWeights;
  return (0, _react.css)(_templateObject12(), colors.muted, 0.5, fonts.caption2, fontSizes.caption2, fontWeights.normal, fontSizes.caption4);
};

exports.fullName = fullName;
var sharpGroteskMedium = {
  'font-weight': '500',
  'font-family': 'Sharp Grotesk Medium',
  'font-style': 'normal',
  src: 'url("https://static.zip.co/fonts/sharp-grotesk-medium-20.woff2") format("woff2")',
  'font-display': 'swap'
};
var sharpGroteskBook = {
  'font-weight': '500',
  'font-family': 'Sharp Grotesk Book',
  'font-style': 'normal',
  src: 'url("https://static.zip.co/fonts/sharp-grotesk-book-20.woff2") format("woff2")',
  'font-display': 'swap'
};
var iframeCardNumber = {
  '@font-face': sharpGroteskMedium,
  'font-family': '"Sharp Grotesk Medium"',
  color: '#FFFFFA',
  'font-size': '15px',
  'font-weight': '500',
  'letter-spacing': '3.5px',
  'word-spacing': '5px',
  '@media screen and (max-width: 280px)': {
    'font-size': '14px'
  },
  '@media screen and (max-width: 260px)': {
    'font-size': '12px'
  }
};
exports.iframeCardNumber = iframeCardNumber;
var iframeCvv = {
  '@font-face': sharpGroteskBook,
  'font-family': '"Sharp Grotesk Book"',
  color: '#FFFFFA',
  'font-size': '11px',
  'font-weight': '400',
  'letter-spacing': '2.4px',
  '@media screen and (max-width: 57.5px)': {
    'font-size': '10px'
  }
};
exports.iframeCvv = iframeCvv;
var iframeCopy = {
  cursor: 'pointer',
  outline: 'none'
};
exports.iframeCopy = iframeCopy;